export default (contest, roundName) => {
  return contest.rounds.filter((item) => item.name === roundName).map((item) => item.categoryName);
};
